"use client";

import React from "react";
import { Brain, Briefcase, Code, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const trainingModules = [{
  title: "SHOT MECHANICS",
  description: "Refine your form, release, and range with pro-tested shooting protocols used in the league.",
  icon: Users,
  bgClass: "bg-card/40 backdrop-blur-md border border-white/5 hover:border-primary/50",
  iconColorClass: "text-primary"
}, {
  title: "OFF THE COURT",
  description: "I'm just as much a mentor on the court as I am off the court. My job is more than just teaching hoop.",
  icon: Brain,
  bgClass: "bg-card/40 backdrop-blur-md border border-white/5 hover:border-primary/50",
  iconColorClass: "text-primary"
}, {
  title: "BALL HANDLING",
  description: "Develop a 'yo-yo' handle with high-intensity dribbling and pressure drills for ultimate control.",
  icon: Code,
  bgClass: "bg-card/40 backdrop-blur-md border border-white/5 hover:border-primary/50",
  iconColorClass: "text-primary"
}, {
  title: "GAME IQ & STRATEGY",
  description: "Learn to read defenses and make pro-level decisions in real-time scenarios to dominate the court.",
  icon: Briefcase,
  bgClass: "bg-card/40 backdrop-blur-md border border-white/5 hover:border-primary/50",
  iconColorClass: "text-primary"
}];
export default function PrePlacementTrainingPrograms() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="74700" id="training-programs" className="bg-background py-24 relative overflow-hidden dark">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={cn("text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-serif font-extrabold text-foreground tracking-tighter uppercase mb-4">
            ELITE PERFORMANCE MODULES
          </h2>
          <p className="text-lg text-secondary font-sans font-light">Pro-level drills designed by Bryan Christiansen to elevate your game. Master the fundamentals and advanced techniques used by elite athletes globally.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {trainingModules.map((module, i) => {
          const Icon = module.icon;
          return <div key={i} data-index={i} className={cn("transition-all duration-700 ease-out delay-[calc(100ms*var(--index))]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            "--index": i
          } as React.CSSProperties}>
                <Card className={cn("group h-full relative overflow-hidden rounded-none transition-all duration-300 hover:-translate-y-[10px] hover:shadow-[0_0_30px_-10px_rgba(255,102,0,0.4)]", module.bgClass)}>
                  <CardHeader className="pb-2 pt-8">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-none bg-background/40 backdrop-blur-md shadow-sm border border-white/10 transition-transform duration-300 group-hover:scale-110 group-hover:border-primary/30">
                      <Icon className={cn("h-8 w-8 transition-all duration-300 group-hover:animate-pulse", module.iconColorClass)} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-serif font-bold text-foreground uppercase tracking-tight leading-tight">
                      {module.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-secondary font-sans font-light line-clamp-3 leading-relaxed">
                      {module.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}